<template>
  <v-card outlined>
    <v-card-text>
      <div class="text-h6 font-weight-bold mb-2">
        {{ unCommentCount }} Missing Comments On Application
      </div>
      <div>
        <div ref="pieContainer" style="width: 100%; height: 300px"></div>
      </div>
      <v-list dense style="max-height: 350px; overflow: auto">
        <template v-for="item in unCommentLeads">
          <v-list-item
            @click="profile(item)"
            :key="item.name"
            v-if="item.unCommentCountLeads !== 0"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.fatherName }}</v-list-item-title>
              <v-list-item-subtitle
                ><span>Created At: </span
                ><span class="font-weight-bold black--text">{{
                  item.createdAt | moment("from", "now")
                }}</span></v-list-item-subtitle
              >
            </v-list-item-content>
            <v-list-item-action-text class="font-weight-bold text-capitalize">{{
              item.LeadStudents[0].status
            }}</v-list-item-action-text>
          </v-list-item>
        </template>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    unCommentCount: {
      type: Number,
      default: 0,
    },
    unCommentLeads: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  // mounted() {
  //   this.renderPie();
  // },
  watch: {
    unCommentLeads: {
      handler() {
        // this.renderPie();
        this.renderDoc();
      },
      deep: true,
    },
  },
  methods: {
    profile(lead) {
      this.$router.push({ path: `/applications/${lead.id}/profile` });
    },
    renderDoc() {
      // Build counts by status
      const statusCounts = {};

      this.unCommentLeads.forEach((lead) => {
        const status = lead.LeadStudents[0]?.status || "Unknown";
        if (!statusCounts[status]) {
          statusCounts[status] = 0;
        }
        statusCounts[status]++;
      });

      // Prepare pie data
      const pieData = Object.keys(statusCounts).map((status) => ({
        name: status,
        y: statusCounts[status],
      }));

      // Determine if data labels should be shown
      const showDataLabels = !this.$vuetify.breakpoint.xsOnly;

      Highcharts.chart(this.$refs.pieContainer, {
        credits: { enabled: false },
        chart: {
          type: "pie",
        },
        title: { text: null },
        tooltip: {
          pointFormat: "<b>{point.y} leads</b> ({point.percentage:.1f}%)",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            innerSize: "60%", // doughnut
            dataLabels: {
              enabled: showDataLabels,
              format: "<b>{point.name}</b>: {point.y}",
            },
            showInLegend: false,
          },
        },
        colors: [
          "#4BC0C0",
          "#36A2EB",
          "#FFCE56",
          "#8E5EA2",
          "#FF6384",
          "#36A200",
        ],
        series: [
          {
            name: "Applications",
            colorByPoint: true,
            data: pieData,
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
</style>